import { Link } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import usePageTitle from '../hooks/usePageTitle';

export default function NotFound() {
  usePageTitle('Page not found');

  return (
    <PageHeader
      eyebrow="Error 404"
      title="Page not found"
      intro="We couldn't find the page you were looking for."
    >
      <Link className="btn btn--primary" to="/">
        Back to home
      </Link>
    </PageHeader>
  );
}
